import React from 'react';

import { TableRow, TableCell } from '@mui/material';

import Node from '../../../common/Node';
import TrplSelect from '../../../common/TrplControls/TrplSelect';

export default React.memo(
  ({ classes, account, accountsTbox, accStatusColor, onAccountTypeChange }) => {
    const isDeactivated = account.access_level === -1;
    const isInvited = account.invitation_sent;

    const td = `${isDeactivated ? classes.op5 : ''} ${!isInvited ? classes.tdPurple : ''}`;

    return (
      <TableRow
        className={`${classes.tableRow} ${account.selected ? 'selected' : ''}`}
        style={{
          background: `${!account.invitation_sent ? '#DBD6E5' : isDeactivated ? '#F8F8F8' : ''}`,
        }}
      >
        <TableCell className={`${classes.tableCell} ${td}`} style={{ color: accStatusColor }}>{account.id}</TableCell>

        <TableCell className={td}>{account.login}</TableCell>

        <TableCell
          style={{
            backgroundColor: `${
              !isInvited && isDeactivated ? '#DBD6E4' : !isInvited ? '#DBD6E5' : isDeactivated ? '#F8F8F8' : ''
            }`,
          }}
        >
          <div className={classes.accountTypeSelectContainer}>
            <TrplSelect
              margin="none"
              complicatedValues
              value={account.access_level || 1}
              onChange={(e) => onAccountTypeChange(account.id, e.target.value)}
              style={{ color: accStatusColor }}
              values={[
                { title: 'Admin', value: 2 },
                { title: 'User', value: 1 },
                { title: 'Deactivated', value: -1 },
              ]}
            />
          </div>
        </TableCell>

        <TableCell className={td}>
          {account.individual &&
            <Node nodeId={account.individual && account.individual.id} isLink size="xs" node={account.individual} />
          }
        </TableCell>

        <TableCell className={td}>
          {account.individual && account.individual.box.a_explicit && Object.keys(accountsTbox)
            .filter(conceptId => account.individual.box.a_explicit.includes(Number(conceptId)))
            .map((conceptId, index) => 
              <Node key={index} nodeId={conceptId} isLink size="xs" node={accountsTbox[conceptId]} />
            )
          }
        </TableCell>

        <TableCell className={td}>
          <div style={{ width: 'fit-content' }}>
            {account.pass ? (
              <React.Fragment>
                <span className={classes.passwordText}>password:</span>{' '}
                <span className={classes.passwordValue}>{account.pass}</span>
              </React.Fragment>
            ) : null}
          </div>
        </TableCell>
      </TableRow>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.account === nextProps.account;
  }
);
